import { Link } from 'react-router-dom';
import { topicCategories } from '@/mocks/topics';

export default function CategorySection() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-primary-600">Categories</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              按领域翻瓜田
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            六个方向，覆盖综艺、剧集、偶像、生活、品牌与赛场。挑一个你最有兴趣的领域开始看。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topicCategories.map((category) => (
            <Link
              key={category.id}
              to={`/topics?category=${category.id}`}
              className="group flex items-start gap-4 border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center bg-secondary-100 text-secondary-900">
                <i className={`${category.icon} text-xl`} aria-hidden="true" />
              </span>
              <span className="flex-1">
                <span className="flex items-center justify-between">
                  <span className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600">
                    {category.name}
                  </span>
                  <span className="text-xs text-foreground-500">{category.count} 个话题</span>
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-foreground-600">
                  {category.blurb}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}